<div class="row mt-2">
  <div class="col-md-12">
    <cap-kopfdatenelement [label]="recht.rechtArt" bodyClass="col-md-10" labelClass="col-md-2">
      <div class="align-read-more">
        <cap-read-more [histInfo]="version.histInfo" [limit]="162" [text]="stichworte"></cap-read-more>
      </div>
    </cap-kopfdatenelement>
  </div>
</div>
<div class="row">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version.histInfo" label="Beleg">
      <cap-kompakt-beleg [item]="version.beleg" [referenzObjectId]="version?.id?.id" [referenzObjectType]="'STANDARDRECHT'">
      </cap-kompakt-beleg>
    </cap-kopfdatenelement>

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="version.beginndatum | datum" label="Entstehungsdatum">
    </cap-kopfdatenelement>

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="version.gesamtwert | betrag" label="Gesamtwert"></cap-kopfdatenelement>

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="version.entschaedigung | betrag" label="Entschädigung">
    </cap-kopfdatenelement>

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="version.ablaufdatum | datum" label="Ablaufdatum"></cap-kopfdatenelement>
  </div>

  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="recht.histInfo" [value]="recht.ereid" label="EREID"></cap-kopfdatenelement>

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="version.fremdeIdentifikation" label="FremdeIdentifikation">
    </cap-kopfdatenelement>

    @if (recht.mUrsprung.access != "NONE" && recht.ursprung) {
      <cap-kopfdatenelement [histInfo]="version.histInfo" label="EntstandenAus">
        <cap-link
          [queryParams]="{ id: recht.ursprung.id.id, versionId: recht.ursprung.version.id.id }"
          [target]="navTargets.NAV_RECHT"
          [tooltipParams]="{ art: recht.ursprung.art | translate }">
          {{ recht.ursprung?.art | titlecase }} {{ recht.ursprung?.rechteId | formatRechteId }}
        </cap-link>
      </cap-kopfdatenelement>
    }

    <cap-kopfdatenelement [histInfo]="version.histInfo" [value]="recht.servitutenregisterNr" label="ServitutenregisterNr">
    </cap-kopfdatenelement>

    <cap-kopfdatenelement label="ErstelltMit">
      <cap-kompakt-timepoint [item]="version.histInfo.vonTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>

    <cap-kopfdatenelement label="GestrichenMit">
      <cap-kompakt-timepoint [item]="version.histInfo.bisTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <cap-kopfdatenelement bodyClass="col-md-10" label="Bemerkung" labelClass="col-md-2">
      <div class="align-read-more">
        <cap-read-more [histInfo]="version?.histInfo" [limit]="162" [text]="version?.bemerkung"></cap-read-more>
      </div>
    </cap-kopfdatenelement>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <cap-kopfdatenelement bodyClass="col-md-10" label="NichtOeffentlicheBemerkung" labelClass="col-md-2">
      @if (version.mBemerkungNichtOeffentlich.access === "NONE") {
        <span>
          {{ "gemaessGrundbuch" | translate }}
        </span>
      } @else {
        <div class="align-read-more">
          <cap-read-more [histInfo]="version.histInfo" [limit]="162" [text]="version?.bemerkungNichtOeffentlich"></cap-read-more>
        </div>
      }
    </cap-kopfdatenelement>
    <div class="title-divider mt-md-0"></div>
  </div>
</div>

<cap-bereinigungsmarkierung [recht]="recht" [version]="version"></cap-bereinigungsmarkierung>
